import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SvcGlobalDataPrefetching } from '../../data-prefetching/svc-global-data-prefetching';
import { ParameterService } from '../../services/parameter/parameter.service';
import { SvcParameters } from '../../enums/svc-parameter.enum';

@Injectable({
  providedIn: 'root',
})
export class WorkCouncilVisibilityService {
  constructor(private _globalDataPrefetching: SvcGlobalDataPrefetching, private _parameterService: ParameterService) {}

  /**
   * Emits the latest value for the WORK_COUNCIL parameter.
   * Falls back to the cached value when the prefetch has already finished.
   */
  public getWorkCouncilActive$(options?: { forceRefresh?: boolean }): Observable<boolean> {
    if (options?.forceRefresh) {
      return this._fetchFromApi();
    }

    const workCouncilItem = this._globalDataPrefetching.data.workCouncils;
    if (workCouncilItem?.value$) {
      return workCouncilItem.value$;
    }

    if (workCouncilItem?.isLoading$) {
      return workCouncilItem.isLoading$.pipe(
        filter((isLoading) => !isLoading),
        map(() => workCouncilItem.value)
      );
    }

    if (typeof workCouncilItem?.value === 'boolean') {
      return of(workCouncilItem.value);
    }

    return this._fetchFromApi();
  }

  private _fetchFromApi(): Observable<boolean> {
    return this._parameterService.getSiteParam(SvcParameters.WorkCouncils).pipe(map((response) => response?.toUpperCase() === 'TRUE'));
  }
}
